import type { QueryKey } from "@tanstack/react-query";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import type { ProviderOperationsSearchRowResponse } from "libs/apiClient";
import { formatDate } from "libs/utils";
import { getProviderOperationsRowKey } from "./getProviderOperationsRowKey";
import { ProviderOperationsActionCell } from "./ProviderOperationsActionCell";
import { ProviderOperationsResultCell } from "./ProviderOperationsResultCell";

type ProviderOperationsTableProps = {
	rows: ProviderOperationsSearchRowResponse[];
	searchQueryKey: QueryKey;
};

export function ProviderOperationsTable({ rows, searchQueryKey }: ProviderOperationsTableProps) {
	if (rows.length === 0) {
		return <p className="provider-operations-message">{_("providerOperations.search.noResults" as keyof Keys)}</p>;
	}

	return (
		<div className="provider-operations-table-wrap">
			<table className="provider-operations-table">
				<thead>
					<tr>
						<th>{_("providerOperations.column.gameId" as keyof Keys)}</th>
						<th>{_("providerOperations.column.provider" as keyof Keys)}</th>
						<th>{_("providerOperations.column.providerRequestId" as keyof Keys)}</th>
						<th>{_("providerOperations.column.requestType" as keyof Keys)}</th>
						<th>{_("providerOperations.column.status" as keyof Keys)}</th>
						<th>{_("providerOperations.column.lastUpdated" as keyof Keys)}</th>
						<th>{_("providerOperations.column.result" as keyof Keys)}</th>
						<th>{_("providerOperations.column.action" as keyof Keys)}</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr key={getProviderOperationsRowKey(row)}>
							<td>{row.gameId}</td>
							<td>{row.provider}</td>
							<td>{row.providerRequestId ?? "-"}</td>
							<td>{row.requestType}</td>
							<td>{row.status}</td>
							<td>{formatDate(row.lastUpdated)}</td>
							<td className="provider-operations-table__result">
								<ProviderOperationsResultCell latestExecution={row.latestExecution} />
							</td>
							<td>
								<ProviderOperationsActionCell row={row} searchQueryKey={searchQueryKey} />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
